/* ============
 * Education Modal Component
 * ============
 */
import mixin from '../../mixins/mixin';
import Vue from 'vue';
import educationalModalService from '../../services/educational_modal';

export default {
  data() {
    return {
      association_code: '',
    };
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

  mixins: [mixin],

  async mounted() {
    if (this.show && localStorage.getItem('isSyncInProgress') === 0) {
      this.openModal('#educational-modal');
    }

    // await educationalModalService.getAssociationCode(this);
  },

  methods: {
    importData() {
      this.closeModal('#educational-modal');
      $('.sync-in-process-modal').addClass('show');
      $('body').addClass('modal-open');
      $('body').append('<div class="modal-backdrop fade show"></div>');
      $('.modal-content').css({ display: 'block' });
      $('.navbar').css({ 'z-index': '0' });

      Vue.$http.get('/rentals/sync-data').then(() => {
      }).catch(() => {

      });
    },
  },

  computed: {},
};



// WEBPACK FOOTER //
// ./src/app/components/educational-modal/educational-modal.js